<template>
  <div class="jytp-con">
    <img :src="itemData.imgUrl" @touchstart="press()" @touchend="raise()" />
    <div class="ds-body">
      <div class="title"><img v-if="itemData.hotType == 1" src="../assets/images/hot.png" alt="">{{itemData.title}}</div>
      <div class="time">{{itemData.pubDate}}</div>
      <div class="video-btn" v-if="itemData.playbackUrl !='' && itemData.playbackUrl != undefined"  @click.stop="gotoVideo(itemData.playbackUrl)">
        <img src="../assets/images/video-btn.png" alt="">
        <div>查看视频解说</div>
      </div>
    </div>
    <div class="savePop" v-if="savePopShow">
      <div class="saveBtn">
        <div @click="saveImg()">保存图片</div>
        <div @click="savePopShow = false;">取消</div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['stockCode'],
  data() {
    return {
      savePopShow:false,// 长按图片弹出保存图片按钮
      id:'',
      itemData:[],
      timer: null,// 长按计时器
      issave:1,
    }
  },
  mounted() {
    this.id = this.$route.query.id
    this.issave = this.$route.query.issave??1

    this.getCylTpData()
  },

  methods: {
    press:function(){

      if(this.issave != 0){
        this.timer = setTimeout(() => {
          this.savePopShow = true;
        }, 500); // 500ms 长按触发
      }

    },
    raise:function(){
      clearTimeout(this.timer);
    },
    // 保存图片
    saveImg:function(){

      this.toUrl("dzh_browser_url&goto=0&screen=345&url="+this.$base64.encode(this.itemData.imgUrl));
    },
    gotoVideo:function(url){
      if(url.includes('?')){
        url += '&DZHSPECIAL=1'
      }else{
        url += '?DZHSPECIAL=1'
      }
      this.toUrl(url);
    },

    //获取产业链图谱 所有数据
    getCylTpData: function () {
      var _this = this;

      this.$http({
        method: "get",
        url : window.config.baiduBucket + '/wap/data/news-web/qlyj/industryChainGraphs.json',
      }).then(function (response) {
        response.data.data.map(function(item){

          if(item.id == _this.id){
            _this.itemData = item;
          }
        })
      });
    },
  },
}
</script>

<style lang="scss" scoped>
.jytp-con{
  font-size: 10px;
  .ds-body {
    padding: .08rem .16rem;
  }
  img {
    width: 100%;
  }
  .title{
    margin: .08rem 0;
    color: #555;
    font-family: PingFang SC;
    font-size: .14rem;
    font-style: normal;
    font-weight: 400;

    white-space: nowrap; /* 防止文字换行 */
    overflow: hidden; /* 隐藏超出部分 */
    text-overflow: ellipsis; /* 超出部分显示省略号 */
    img {
      width: .1rem;
      height: .13rem;
    }
  }

  .time {
    margin-bottom: .08rem;
    color:#999;
    font-family: PingFang SC;
    font-size: .14rem;
    font-style: normal;
    font-weight: 400;
  }

  .video-btn {
    margin-bottom: .2rem;
    width: 1.1rem;
    white-space: nowrap; /* 防止文字换行 */
    border-radius: .32rem;
    background: rgba(40, 109, 247, 0.90);
    padding: .04rem .08rem;
    color: #FFF;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: PingFang SC;
    font-size: .11rem;
    font-style: normal;
    font-weight: 400;
    img {
      width: .12rem;
      display: block;
      margin-right: .04rem;
    }
  }
}
.blackTheme{
  .jytp-con{
    .title{

      color: #AAB9D1;

    }

    .time {

      color:#999;

    }
  }
}

.savePop {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  .saveBtn {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background: #fff;

    text-align: center;
    div{
      color: #333333;
      font-size: .16rem;
      padding: .16rem 0;
      border-bottom: 1px solid #F8F8FA;
    }

  }
}

</style>